import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Layout/Header';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import WoprPage from './pages/WoprPage';
import MandatumPage from './pages/MandatumPage';
import IdleveilPage from './pages/IdleveilPage';
import ProjectsPage from './pages/ProjectsPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import { preloadImages } from './utils/preloader';
import './app.css';

import heroProducts from './assets/optimized/asset4.webp';
import heroProjects from './assets/optimized/asset7.webp';
import heroContact from './assets/optimized/asset9.webp';
import asset1 from './assets/optimized/asset1.webp';
import asset2 from './assets/optimized/asset2.webp';
import asset3 from './assets/optimized/asset3.webp';

function App() {
  useEffect(() => {
    preloadImages([
      heroProducts,
      heroProjects,
      heroContact,
      asset1,
      asset2,
      asset3
    ]);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/mandatum" element={<MandatumPage />} />
            <Route path="/products/wopr" element={<WoprPage />} />
            <Route path="/products/idleveil" element={<IdleveilPage />} />
                        <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
